export const PRIMARY = '#FE6642';
export const SECONDARY = '#252F36';
export const FLYTLIGHTGRAY = '#F7F6F6';
export const GREEN = '#499B23';
export const INFO_GREEN = '#ECF5E9';
export const SUCCESS_GREEN = '#005F47';
export const RED = '#A71000';
export const YELLOW = '#FBAD16';
export const GRAY = '#6F6F6F';
export const BLACK = '#000000';
export const WHITE = '#FFFFFF';
export const DARK_GRAY = '#242323';
export const MEDIUM_GRAY = '#D6D6D6';
export const LIGHT_GRAY = '#FAFAFA';
export const INFO_BLUE = '#2E4C67';
export const INFO_BLUE_LIGHT = '#EAF3FA';
export const INFO_BLUE_BORDER = '#C7DEF0';
export const BORDER_GRAY = '#B8B8B8';
export const LIGHT_PRIMARY = '#ffa38e7e';